import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';

import { AccessRole, UserData } from '@deltager/organizers/admin/shared/models/LoginData';
import { UserService } from '@deltager/organizers/admin/core/services/user.service';
import { AppSettingsService } from '../../app-settings/app-settings.service';

@Injectable()
export class UserDataResolver {
  constructor(
    private userService: UserService,
    private router: Router,
    private appSettingsService: AppSettingsService,
  ) {}
  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<UserData> {
    const userData = await this.userService.getUserData();

    if (userData) {
      const isLimitedAccess = route.data.isLimitedAccess;
      const allowRoles = (route.data.allowRoles ?? []) as AccessRole[];

      if (isLimitedAccess && this.userService.isLimitedAccessRole(allowRoles)) {
        this.router.navigate(['/events']);
      }

      return userData;
    } else {
      this.appSettingsService.goToLogin();

      return null;
    }
  }
}
